/*
 * 能发送异步ajax请求的函数模块
 * 封装axios库
 * 函数的返回值是promise对象
 *
 * 1、优化：统一处理请求异常。
 *       在外层包一个Promise对象
 *       请求出错不用reject，使用错误提示。
 *
 * 注意: 后台接口异常、网络异常都在axios的请求返回中处理了，调用方无需处理异常和失败情况
 *
 * */
import { BaseUrl, ReqType, LoginPath } from './config';
import axios from 'axios';
import { toast } from 'react-toastify';
import { history } from '../history';
import { storageInfo } from '../utils/storageUtils';
import { store } from '../redux/store';
import { AUTH_UNAUTHORIZED } from '../redux/action-types';

export function ajax(url, data = {}, type = ReqType.GET) {
    // 填充完整url
    url = BaseUrl + url;
    //自动添加token参数
    const token = storageInfo.getToken();
    let headers = { token: token };
    // let headers = { token: token,referrer:'2048av.com' };

    // let headers = { token };
    
    // console.log('ajax token', url, token);
  
    return new Promise((resolve, reject) => {
      // 1、执行ajax请求
      let promise =
        ReqType.GET === type
          ? axios.get(url, { headers: headers, params: data })
          : axios.post(url, data, { headers });

      // let promise = axios.get(url, { headers: headers, params: data });
      // if(ReqType.POST === type) {
      //   promise = axios.post(url, data, { headers });
      // }else if(ReqType.PUT === type) {
      //   promise = axios.put(url, data, { headers });
      // }
  
      // 2、成功就resolve
      // 3、 失败，不调用reject（如果调用，那么外面就会执行catch中的错误处理），显示异常信息。
      promise
        .then((response) => {
          let data = response.data;
          // console.log('ajax response', response);
          if (parseInt(data.status) !== 0) {
            //接口返回了错误信息，处理不成功的情况都在这里处理了
            throw new Error(data.msg);
          }
          //这里直接返回data数据
          return resolve(data.data);
        })
        .catch((err) => {
          //获取请求错误码
          let status = err?.response?.status || 0;
          console.log('ajax err', status, err, history.location.pathname);
          //判断如果是，没有访问权限，并且不在登录页面，自动跳转到登录页面
          if (status === 401 && history.location.pathname !== LoginPath) {
            //通知redux需要重新登录
            const { dispatch } = store;
            //清除本地存储的用户信息
            storageInfo.delUserInfo();
            setTimeout(() => {
              // console.log('页面跳转，通知redux授权异常，跳转到登录页面');
              dispatch({
                type: AUTH_UNAUTHORIZED,
              });
            }, 2000);
            //设置定时器，显示错误显示3秒以后自动跳转到登录页面
            toast.error('401 Unauthorized access', {
              autoClose: 2000,
            });
          } else {
            if (err.message && err.message.length > 1) {
              // toast.error(err.message);
              console.log('err.message', err.message);
            }
          }
        });
    });
  }
  